import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Style and SEO
import { Col, Grid, Row, styled } from '@smooth-ui/core-sc';
import Helmet from 'react-helmet';

import { withSettings } from '../../containers/WebApp/SettingsContext';
import PrivateComponent from '_platform/src/utils/PrivateComponent';
import HeroBanner from '../../components/CustomComponents/Banners/HeroBanner';

const AlternateContainer = styled.div`
  background-color: #ececf1;
  padding: 2em 0;
  text-align: center;

  h1 {
    font-weight: normal;
  }
  p {
    line-height: 1.5;
  }
`;

const HomePage = ({ settings }) => {
  return (
    <div className="page-container">
      <Helmet>
        {/* <meta name="description" content="Page description" /> */}
      </Helmet>

      <PrivateComponent
        redirectOnError={{
          pathname: settings.settingsApp.loginPagePath || '/login/',
        }}
      >
        <HeroBanner />
        <AlternateContainer>
          <Grid>
            <Row justifyContent="center">
              <Col xs={12}>
                <h1>Welcome to Harman Rewards</h1>
                <h4>
                  Sell JBL and Harman Kardon products in store from 9 November
                  2026 to 3 January 2027, to earn points with
                  harmanrewards.co.nz.
                </h4>
                <p>
                  You earn points by selling JBL & Harman Kardon products direct
                  to customers in store (commercial and online sales are
                  excluded).
                </p>
                <p>
                  To qualify for Harman Rewards, you <strong>MUST</strong>{' '}
                  register, complete the Training module and answer all
                  questions correctly. Please click the{' '}
                  <Link to="/training">Training</Link> button at the top of the
                  page to complete the training module.
                </p>
                <p>
                  You will receive 10 bonus points by completing our training
                  module. Please head to the{' '}
                  <Link to="/training">Training</Link> tab to take the quiz. All
                  questions must be answered correctly to receive your 10 bonus
                  points.
                </p>
                <p>
                  Once you are awarded points (mid Jan 2027), these points must
                  be redeemed by 11:59pm NZDT 12 February 2027.
                </p>
              </Col>
            </Row>
          </Grid>
        </AlternateContainer>
      </PrivateComponent>
    </div>
  );
};

HomePage.propTypes = {
  settings: PropTypes.object.isRequired,
};

export default withSettings(HomePage);
